import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
import { cn } from '@/lib/ui/utils';
import { RIGHT_COLUMN_CARD_RESTING_SHELL } from './right-column-card-chrome';

// Resting-state skeleton for the Hot-Takes carousel card. Used both by the
// route-level RightColumnSkeleton and by BreakingViewsWidget itself while its
// hot-theses query is pending, so the skeleton → content hand-off is seamless.
export function HotTakesCardSkeleton(t0) {
  const $ = _c(10);
  const {
    testId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(RIGHT_COLUMN_CARD_RESTING_SHELL, "flex min-h-[11.5rem] shrink-0 flex-col gap-3");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4 w-28" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-between">{t2}<div className="flex items-center gap-1.5"><Skeleton className="h-1.5 w-6 rounded-full" /><Skeleton className="size-1.5 rounded-full" /><Skeleton className="size-1.5 rounded-full" /></div></div>;
    t4 = <Skeleton className="h-4 w-[70%]" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-1.5"><Skeleton className="h-5 w-[45%]" /></div>;
    t6 = <Skeleton className="h-px w-full" />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex min-w-0 items-center gap-2"><Skeleton className="size-8 shrink-0 rounded-full" /><Skeleton className="h-3 w-24" /></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center justify-between gap-3">{t7}<div className="flex shrink-0 flex-col items-end gap-1"><Skeleton className="h-4 w-10" /><Skeleton className="h-3 w-8" /></div></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== testId) {
    t9 = <div className={t1} data-testid={testId}>{t3}{t4}{t5}{t6}{t8}</div>;
    $[8] = testId;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}